import { create } from "@bufbuild/protobuf";
import { AssetFilterSchema } from "#gen/asset/v1/asset_pb.js";
import type { PaginationArguments, PaginationPageInfo } from "#gen/common/v1/pagination_pb.js";
import { TagService } from "#gen/tag/v1/tag_pb.js";
import { createClient, type ClientOptions } from "#lib/api/api.js";
import { handleError } from "#lib/api/error.js";
import { PUBLIC_URLS } from "#lib/url.js";
import type { CallOptions, Client } from "@connectrpc/connect";

export interface TagList {
	tags: string[];
	pageInfo?: PaginationPageInfo;
}

export class TagClient {
	private client: Client<typeof TagService>;

	constructor(options?: () => ClientOptions) {
		this.client = createClient(PUBLIC_URLS.tags || "/", TagService, options);
	}

	async listTags(orgId: string, workspaceId: string, filter?: string, pagination?: PaginationArguments, options?: CallOptions): Promise<TagList> {
		try {
			const res = await this.client.listTags(
				{
					id: {
						case: "workspaceId",
						value: workspaceId,
					},
					filter: create(AssetFilterSchema, {
						namePrefix: filter,
					}),
					paginate: pagination,
				},
				options,
			);
			return res;
		} catch (e) {
			throw handleError(e);
		}
	}
}
